import { render, staticRenderFns } from "./MemosReviewScreen.vue?vue&type=template&id=702568aa&scoped=true&"
import script from "./MemosReviewScreen.vue?vue&type=script&lang=js&"
export * from "./MemosReviewScreen.vue?vue&type=script&lang=js&"
import style0 from "./MemosReviewScreen.vue?vue&type=style&index=0&id=702568aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702568aa",
  null
  
)

/* custom blocks */
import block0 from "./MemosReviewScreen.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports